import { render, staticRenderFns } from "./canvascode.vue?vue&type=template&id=b42f730e&scoped=true"
import script from "./canvascode.vue?vue&type=script&lang=js"
export * from "./canvascode.vue?vue&type=script&lang=js"
import style0 from "./canvascode.vue?vue&type=style&index=0&id=b42f730e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42f730e",
  null
  
)

export default component.exports